var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2451 1.54246L11.4118 13.1858C11.1906 13.6274 10.636 13.7808 10.2193 13.5156L7.23223 11.6154C7.19611 11.644 7.15712 11.6701 7.11538 11.6931L5.2354 12.7284C4.68001 13.0343 4.00006 12.6325 4.00006 11.9985L3.99969 9.56393C3.99954 9.56199 3.99939 9.56005 3.99925 9.55811L1.05267 7.68228C0.476223 7.31545 0.561934 6.44894 1.19907 6.20215L16.1991 0.392113C16.9097 0.11685 17.5865 0.86109 17.2451 1.54246ZM14.788 2.72598L3.33793 7.16102L5.19579 8.34337L8.97446 6.25027C9.37705 6.02725 9.88421 6.17282 10.1072 6.57541C10.3303 6.978 10.1847 7.48516 9.78209 7.70819L6.79579 9.36171L10.3352 11.6138L14.788 2.72598Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessage);
export default __webpack_public_path__ + "static/media/send-message.7ce49fe6bb013cc638450a04511f7f6e.svg";
export { ForwardRef as ReactComponent };